import type { CrmContact } from '@integrations/crm-contacts/contracts/crm-contact.contract';

import { inject } from '@angular/core';
import type { CreateQueryOptions } from '@tanstack/angular-query-experimental';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { retryTransient } from '@integrations/shared/retry-policy';

import { CrmContactsApiService } from '../api/crm-contacts-api.service';

export const CRM_CONTACTS_QUERY_KEY = ['crm-contacts'] as const;

type CrmContactsQueryOverrides = Partial<Omit<CreateQueryOptions<CrmContact[]>, 'queryKey' | 'queryFn'>>;

export function injectCrmContactsQuery(optionsFn?: () => CrmContactsQueryOverrides) {
    const api = inject(CrmContactsApiService);

    return injectQuery(() => ({
        staleTime: 5 * 60 * 1000, // 5 minutes
        // A definitive 4xx is how "the account does not have this" is detected, so it must
        // not be retried; a transient failure gets a few attempts instead of being mistaken
        // for that answer (#71534).
        retry: retryTransient,
        queryKey: CRM_CONTACTS_QUERY_KEY,
        queryFn: () => lastValueFrom(api.getContactAttributes()),
        ...optionsFn?.(),
    }));
}
